import { render, staticRenderFns } from "./InternalPromosExpiringInAWeek.vue?vue&type=template&id=02541773"
import script from "./InternalPromosExpiringInAWeek.vue?vue&type=script&lang=js"
export * from "./InternalPromosExpiringInAWeek.vue?vue&type=script&lang=js"
import style0 from "./InternalPromosExpiringInAWeek.vue?vue&type=style&index=0&id=02541773&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports